module.exports = __webpack_public_path__ + "img/alberick-medisch-centrum-primary-logo-centered.86f93d63.svg";